import * as actions from '../../utils/Actions';

const initialState = {
    showPageLoader: false,
    branchList: [],
    formsList: null,
    instituteId:null,
    branchDetails:null,
    courseList:[],
    stateList:[],
    cityList:[],
    casteList:[],
    talukaList:[],
    documentList:[],
    academicYearList:[],
    subjectPreferenceList:[]


}

export default function branch(state = initialState, action){

    if (typeof state === 'undefined') {
        return state;
    }

    switch (action.type){
     
        case actions.RESET_BRANCH_DATA:
            return {
                ...state,
                showPageLoader: false,
                formsList:null
            }
            

        case actions.RESET_CITYLIST:
            return {
                ...state,
                cityList:[{ "id": 11001,"active":true, "name": "OTHER" }]
            }
        
        case actions.RESET_TALUKALIST:
            return {
                ...state,
                talukaList:[{ "id": 12001,"active":true, "name": "OTHER" }]
            }  

        case actions.pending(actions.GET_INSTITUTE_ALL_BRANCHES):
            return {
                ...state,
                showPageLoader: true,
                formsList:null
            }

        case actions.fulfilled(actions.GET_INSTITUTE_ALL_BRANCHES):
            let id =action.meta
            return {
                ...state,
                branchList: action.payload.data,
                instituteId:id,
                showPageLoader: false
            }

        case actions.rejected(actions.GET_INSTITUTE_ALL_BRANCHES):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.GET_FORMS):
            return {
                ...state
            }

        case actions.fulfilled(actions.GET_FORMS):
            return {
                ...state,
                formsList: action.payload.data,
                showPageLoader: false
            }

        case actions.rejected(actions.GET_FORMS):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.GET_BRANCH_DETAILS):
            return {
                ...state,
                showPageLoader: true,
            }

        case actions.fulfilled(actions.GET_BRANCH_DETAILS):
            return {
                ...state,
                branchDetails: action.payload.data,
                showPageLoader: false
            }

        case actions.rejected(actions.GET_BRANCH_DETAILS):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.GET_COURSE_LIST):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_COURSE_LIST):
            return {
                ...state,
                courseList: action.payload.data,
                showPageLoader: false

            }

        case actions.rejected(actions.GET_COURSE_LIST):
            return {
                ...state,
                showPageLoader: false

            }

        case actions.pending(actions.GET_ACADEMIC_YEAR):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_ACADEMIC_YEAR):
            return {
                ...state,
                academicYearList: action.payload.data,
                showPageLoader: false

            }

        case actions.rejected(actions.GET_ACADEMIC_YEAR):
            return {
                ...state,
                showPageLoader: false

            }

        case actions.pending(actions.GET_STATES):
            return {
                ...state,
                showPageLoader: true

            }

        case actions.fulfilled(actions.GET_STATES):
            return {
                ...state,
                stateList: action.payload.data,
                showPageLoader: false

            }

        case actions.rejected(actions.GET_STATES):
            return {
                ...state,
                showPageLoader: false

            }

        case actions.pending(actions.GET_CITY):
            return {
                ...state,
                showPageLoader: true

            }

        case actions.fulfilled(actions.GET_CITY):
            let tempCity = action.payload.data;
            tempCity.push({ "id": 11001,"active":true, "name": "OTHER" })
            return {
                ...state,
                cityList: tempCity,
                showPageLoader: false

            }

        case actions.rejected(actions.GET_CITY):
            return {
                ...state,
                showPageLoader: false

            }

            
        case actions.pending(actions.GET_CASTES):
            return {
                ...state,
                showPageLoader: true

            }

        case actions.fulfilled(actions.GET_CASTES):
            return {
                ...state,
                casteList: action.payload.data,
                showPageLoader: false

            }

        case actions.rejected(actions.GET_CASTES):
            return {
                ...state,
                showPageLoader: false

            }
            
        case actions.pending(actions.GET_TALUKA):
            return {
                ...state,
                showPageLoader: true

            }

        case actions.fulfilled(actions.GET_TALUKA):
            let tempTaluka = action.payload.data;
            tempTaluka.push({ "id": 12001,"active":true, "name": "OTHER" })
            return {
                ...state,
                talukaList: tempTaluka,
                showPageLoader: false

            }

        case actions.rejected(actions.GET_TALUKA):
            return {
                ...state,
                showPageLoader: false

            } 
            
        case actions.pending(actions.GET_DOCUMENTLIST):
            return {
                ...state,
                showPageLoader: true

            }

        case actions.fulfilled(actions.GET_DOCUMENTLIST):
            
            return {
                ...state,
                documentList:  action.payload.data,
                showPageLoader: false

            }

        case actions.rejected(actions.GET_DOCUMENTLIST):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.GET_SUB_CASTES):
            return {
                ...state,
                showPageLoader: true

            }

        case actions.fulfilled(actions.GET_SUB_CASTES):
            
            return {
                ...state,
                subCastList:  action.payload.data,
                showPageLoader: false

            }

        case actions.rejected(actions.GET_SUB_CASTES):
            return {
                ...state,
                showPageLoader: false
            }

            case actions.pending(actions.GET_SUBJECT_PREFERENCE_LIST):
                return {
                    ...state,
                    showPageLoader: true
    
                }
    
            case actions.fulfilled(actions.GET_SUBJECT_PREFERENCE_LIST):
                
                return {
                    ...state,
                    subjectPreferenceList:  action.payload.data,
                    showPageLoader: false
    
                }
    
            case actions.rejected(actions.GET_SUBJECT_PREFERENCE_LIST):
                return {
                    ...state,
                    showPageLoader: false
                }    

                
        default:
            return {...state}
    }

}